var smIconModule = angular.module('smartIconModule', []);
smIconModule.directive('smartIcon', [function () {
  'use strict';
  return {
    restrict: 'EA',
    template: '<span ng-include="url" onload="loaded=loaded+1"></span>',
    replace: false,
    scope: {
      url: '@',
      width: '@',
      height: '@',
      color: '@'
    },
    link: function (scope, element, attrs) {
      scope.loaded = 0;
      if (scope.width && !scope.height) {
        scope.height = scope.width;
      } else if (scope.height && !scope.width) {
        scope.width = scope.height;
      }
      scope.$watch(function () { return element[0].childNodes.length; }, function (n, o) {
        if(n != o) {
          updateSvg();
        }
      });

      scope.$watch('loaded', function (n, o) {
        if(n != o) {
          updateSvg();
        }
      });


      function updateSvg(){
        var svg = element.find('svg');
        svg.css({
          'height': scope.height,
          'width': scope.width
        });
        var path = element.find('path');
        path.css({
          'fill': scope.color
        });
      }

    }
  };
}]);
module.exports = smIconModule;


// WEBPACK FOOTER //
// ./web/js/module/smart-icon/smartIcon.js